import {ChangeDetectionStrategy, Component} from '@angular/core';
import {MatCard, MatCardContent} from '@angular/material/card';
import {CheckoutsSelectors} from '@store/checkouts/checkouts.selectors';
import {SelectPipe} from '@aviary/pipes/select.pipe';
import {CoverImageComponent} from '@aviary/components/cover-image/cover-image.component';
import {NamedRouterLinkDirective} from '@lib/directives/named-router-link/named-router-link.directive';
import {HiddenUntilLoadedDirective} from '@aviary/directives/hidden-until-loaded.directive';
import {ArrowTextButtonComponent} from '@lib/components/arrow-text-button/arrow-text-button.component';
import {PatronSelectors} from '@store/patron/patron.selectors';
import {MatTooltip} from '@angular/material/tooltip';

@Component({
  selector: 'px-recent-borrowing-history',
  templateUrl: './recent-borrowing-history.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatCard, SelectPipe, MatCardContent, CoverImageComponent, NamedRouterLinkDirective, HiddenUntilLoadedDirective, ArrowTextButtonComponent, MatTooltip
  ]
})
export class RecentBorrowingHistoryComponent {
  public readonly selectors = CheckoutsSelectors.BorrowingHistory;
  public readonly patronSelectors = PatronSelectors.Auth;
}
